import {useAppSelector} from "@/hooks";

export const useAreFontsLoading = (): boolean => {
    return useAppSelector((state) => {
        return state.fontSelector.areFontsLoading;
    });
}